// import React from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   FiFacebook, 
//   FiInstagram,
//   FiTwitter, 
//   FiLinkedin, 
//   FiPackage,
//   FiStar,
//   FiHome,
//   FiShoppingCart,
//   FiUser,
//   FiHeart,
//   FiShield,
//   FiFileText,
//   FiPhone,
//   FiMail,
//   FiBriefcase 
// } from 'react-icons/fi';
// import { 
//   FaCcVisa, 
//   FaCcMastercard, 
//   FaMoneyBillWave 
// } from 'react-icons/fa';
// import logo from "../assests/logo/Havbit6.png";
// import upiLogo from "../assests/upi.png";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   const mainCategories = [
//     { "_id": "692ecfa82f8d4f61133ca348", "name": "Snacks" },
//     { "_id": "69328e258ec00e5b1605beae", "name": "Bars & Bites" },
//     { "_id": "693291818ec00e5b1605bed2", "name": "Dry Fruits & Nuts" },
//     { "_id": "693295a48ec00e5b1605bf27", "name": "Superfoods" },
//     { "_id": "693296238ec00e5b1605bf2e", "name": "Beverages" }
//   ];

//   const moreCategories = [
//     { "_id": "693296618ec00e5b1605bf31", "name": "Natural Products" },
//     { "_id": "6932a77801f804e9a3267247", "name": "Breakfast Essentials" }
//   ];

//   // ✅ UPDATED QUICK LINKS
//   const quickLinks = [
//     { name: "Home", path: "/", icon: <FiHome className="w-4 h-4" /> },
//     { name: "Wishlist", path: "/wishlist", icon: <FiHeart className="w-4 h-4" /> },
//     { name: "Products", path: "/products", icon: <FiHeart className="w-4 h-4" /> },
//     { name: "Cart", path: "/cart", icon: <FiShoppingCart className="w-4 h-4" /> },
//     { name: "Account", path: "/account", icon: <FiUser className="w-4 h-4" /> },

//       { name: "Blogs", path: "/blogs", icon: <FiFileText className="w-4 h-4" /> },
//  // ✅ ADD THIS LINE
//   { name: "About Us", path: "/about", icon: <FiFileText className="w-4 h-4" /> },
//     // 🔥 BRANDS ADDED
//     { name: "Brands", action: "openBrands", icon: <FiStar className="w-4 h-4" /> }
//   ];

//   const policyLinks = [
//     { name: "Refund Policy", path: "/refund-policy", icon: <FiShield className="w-4 h-4" /> },
//     { name: "Privacy Policy", path: "/privacy-policy", icon: <FiFileText className="w-4 h-4" /> },
//     { name: "Shipping Policy", path: "/shipping-policy", icon: <FiPackage className="w-4 h-4" /> },
//     { name: "Terms & Conditions", path: "/terms-and-conditions", icon: <FiFileText className="w-4 h-4" /> },
//     { name: "Contact Us", path: "/contact-us", icon: <FiPhone className="w-4 h-4" /> },
//     { name: "Support", path: "/support", icon: <FiMail className="w-4 h-4" /> }
//   ];

//   return (
//     <footer className="bg-white text-gray-800 pt-8 pb-6 mt-auto border-t border-gray-200">
//       <div className="container mx-auto px-4">

//         <div className="grid grid-cols-2 lg:grid-cols-5 gap-6 mb-8">

//           <div className="col-span-2 lg:col-span-1">
//             <Link to="/" className="mb-4 block">
//               <img src={logo} alt="Havbit" className="h-12" />
//             </Link>

//             <p className="text-gray-600 text-sm mb-4">
//               Premium natural foods, superfoods & wellness products.
//             </p>

//             <div className="flex space-x-3">
//               <FiInstagram />
//               <FiFacebook />
//               <FiTwitter />
//               <FiLinkedin />
//             </div>
//           </div>

//           {/* Categories */}
//           <div>
//             <h3 className="font-semibold mb-3 flex items-center">
//               <FiPackage className="mr-2 text-red-600" /> Categories
//             </h3>
//             {[...mainCategories, ...moreCategories].map(cat => (
//               <Link key={cat._id} to={`/category/${cat.name}`} className="block text-sm text-gray-600 hover:text-red-600">
//                 {cat.name}
//               </Link>
//             ))}
//           </div>

//           {/* ✅ QUICK LINKS UPDATED */}
//           <div>
//             <h3 className="font-semibold mb-3 flex items-center">
//               <FiStar className="mr-2 text-red-600" /> Quick Links
//             </h3>

//             <ul className="space-y-2">
//               {quickLinks.map((link) => (
//                 <li key={link.name}>

//                   {link.action === "openBrands" ? (
//                     <div
//                       onClick={() => window.dispatchEvent(new Event("openBrands"))}
//                       className="cursor-pointer text-sm text-gray-600 flex items-center hover:text-red-600"
//                     >
//                       <span className="mr-2">{link.icon}</span>
//                       {link.name}
//                     </div>
//                   ) : (
//                     <Link to={link.path} className="text-sm text-gray-600 flex items-center hover:text-red-600">
//                       <span className="mr-2">{link.icon}</span>
//                       {link.name}
//                     </Link>
//                   )}

//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Policies */}
//           <div>
//             <h3 className="font-semibold mb-3 flex items-center">
//               <FiShield className="mr-2 text-red-600" /> Policies
//             </h3>
//             {policyLinks.map(link => (
//               <Link key={link.name} to={link.path} className="block text-sm text-gray-600 hover:text-red-600">
//                 {link.name}
//               </Link>
//             ))}
//           </div>

//           {/* Work */}
//           <div>
//             <h3 className="font-semibold mb-3 flex items-center">
//               <FiBriefcase className="mr-2 text-red-600" /> Work With Us
//             </h3>
//             <Link to="https://seller.havbit.in" className="bg-red-400 text-white px-3 py-2 rounded">
//               Become a Seller
//             </Link>
//           </div>

//         </div>

//         {/* <div className="border-t pt-4 flex justify-between text-sm text-gray-600">
//           <p>© {currentYear} Havbit</p>
//           <div className="flex gap-3">
//             <FaCcVisa />
//             <FaCcMastercard />
//             <FaMoneyBillWave />
//           </div>
//         </div> */}
//         {/* Bottom Section */}
// <div className="border-t border-gray-200 pt-6">
//   <div className="flex flex-col md:flex-row justify-between items-center gap-4">

//     {/* Copyright */}
//     <div className="text-center md:text-left">
//       <p className="text-gray-600 text-xs md:text-sm">
//         &copy; {currentYear} Havbit Global Private Limited. All rights reserved.
//       </p>
//     </div>

//     {/* Payment Methods */}
//     <div className="flex flex-wrap justify-center items-center gap-3">

//       {/* UPI */}
//       <div className="h-8 w-14 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 p-1">
//         <img
//           src={upiLogo}
//           alt="UPI Payment"
//           className="h-full object-contain"
//         />
//       </div>

//       {/* Visa */}
//       <div className="h-8 px-2 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-blue-700">
//         <FaCcVisa size={28} />
//       </div>

//       {/* Mastercard */}
//       <div className="h-8 px-2 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-orange-500">
//         <FaCcMastercard size={28} />
//       </div>

//       {/* COD */}
//       <div className="h-8 px-3 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-gray-700 gap-1.5">
//         <FaMoneyBillWave className="text-green-600" size={20} />
//         <span className="text-[10px] font-bold">COD</span>
//       </div>

//     </div>
//   </div>
// </div>

//       </div>
//     </footer>
//   );
// };

// export default Footer;















import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiFacebook, 
  FiInstagram,
  FiTwitter, 
  FiLinkedin, 
  FiPackage,
  FiStar,
  FiHome,
  FiShoppingCart,
  FiUser,
  FiHeart,
  FiShield,
  FiFileText,
  FiPhone,
  FiMail,
  FiBriefcase 
} from 'react-icons/fi';
import { 
  FaCcVisa, 
  FaCcMastercard, 
  FaMoneyBillWave 
} from 'react-icons/fa';
import logo from "../assests/logo/Havbit6.png";
import upiLogo from "../assests/upi.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const mainCategories = [
    { "_id": "692ecfa82f8d4f61133ca348", "name": "Snacks" },
    { "_id": "69328e258ec00e5b1605beae", "name": "Bars & Bites" },
    { "_id": "693291818ec00e5b1605bed2", "name": "Dry Fruits & Nuts" },
    { "_id": "693295a48ec00e5b1605bf27", "name": "Superfoods" },
    { "_id": "693296238ec00e5b1605bf2e", "name": "Beverages" }
  ];

  const moreCategories = [
    { "_id": "693296618ec00e5b1605bf31", "name": "Natural Products" },
    { "_id": "6932a77801f804e9a3267247", "name": "Breakfast Essentials" }
  ];

  const quickLinks = [
    { name: "Home", path: "/", icon: <FiHome className="w-4 h-4" /> },
    { name: "Wishlist", path: "/wishlist", icon: <FiHeart className="w-4 h-4" /> },
    { name: "Products", path: "/products", icon: <FiHeart className="w-4 h-4" /> },
    { name: "Cart", path: "/cart", icon: <FiShoppingCart className="w-4 h-4" /> },
    { name: "Account", path: "/account", icon: <FiUser className="w-4 h-4" /> },
    { name: "Blogs", path: "/blogs", icon: <FiFileText className="w-4 h-4" /> },
    { name: "About Us", path: "/about", icon: <FiFileText className="w-4 h-4" /> },
    { name: "Brands", action: "openBrands", icon: <FiStar className="w-4 h-4" /> }
  ];

  const policyLinks = [
    { name: "Refund Policy", path: "/refund-policy" },
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Shipping Policy", path: "/shipping-policy" },
    { name: "Payment Policy", path: "/payment-policy" },
    { name: "Cancellation Policy", path: "/cancellation-policy" },
    { name: "Community Guidelines", path: "/community-guidelines" },
    { name: "Cookie Policy", path: "/cookie-policy" },
    { name: "Grievance Redressal Policy", path: "/grievance-policy" },
    { name: "Intellectual Property Policy", path: "/intellectual-property-policy" },
    { name: "Terms & Conditions", path: "/terms-and-conditions" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Support", path: "/support" }
  ];

  return (
    <footer className="bg-white text-gray-800 pt-8 pb-6 mt-auto border-t border-gray-200">
      <div className="container mx-auto px-4">

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-6 mb-8">

          {/* Logo */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="mb-4 block">
              <img src={logo} alt="Havbit" className="h-12" />
            </Link>

            <p className="text-gray-600 text-sm mb-4">
              Premium natural foods, superfoods & wellness products.
            </p>

            <div className="flex space-x-3">
              <FiInstagram />
              <FiFacebook />
              <FiTwitter />
              <FiLinkedin />
            </div>
          </div>

          {/* ✅ Categories FIXED */}
          <div>
            <h3 className="font-semibold mb-3 flex items-center">
              <FiPackage className="mr-2 text-red-600" /> Categories
            </h3>

            <ul className="space-y-2">
              {[...mainCategories, ...moreCategories].map(cat => (
                <li key={cat._id}>
                  <Link 
                    to={`/category/${cat.name}`} 
                    className="text-sm text-gray-600 hover:text-red-600"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links (same as before) */}
          <div>
            <h3 className="font-semibold mb-3 flex items-center">
              <FiStar className="mr-2 text-red-600" /> Quick Links
            </h3>

            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  {link.action === "openBrands" ? (
                    <div
                      onClick={() => window.dispatchEvent(new Event("openBrands"))}
                      className="cursor-pointer text-sm text-gray-600 flex items-center hover:text-red-600"
                    >
                      <span className="mr-2">{link.icon}</span>
                      {link.name}
                    </div>
                  ) : (
                    <Link to={link.path} className="text-sm text-gray-600 flex items-center hover:text-red-600">
                      <span className="mr-2">{link.icon}</span>
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* ✅ Policies FIXED */}
          <div>
            <h3 className="font-semibold mb-3 flex items-center">
              <FiShield className="mr-2 text-red-600" /> Policies
            </h3>

            <ul className="space-y-2">
              {policyLinks.map(link => (
                <li key={link.name}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-gray-600 hover:text-red-600"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Work */}
          <div>
            <h3 className="font-semibold mb-3 flex items-center">
              <FiBriefcase className="mr-2 text-red-600" /> Work With Us
            </h3>
            <Link to="https://seller.havbit.in" className="bg-red-400 text-white px-3 py-2 rounded">
              Become a Seller
            </Link>
          </div>

        </div>

        {/* Bottom */}
        <div className="border-t border-gray-200 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">

            <div className="text-center md:text-left">
              <p className="text-gray-600 text-xs md:text-sm">
                &copy; {currentYear} Havbit Global Private Limited. All rights reserved.
              </p>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-3">

              <div className="h-8 w-14 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 p-1">
                <img src={upiLogo} alt="UPI Payment" className="h-full object-contain" />
              </div>

              <div className="h-8 px-2 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-blue-700">
                <FaCcVisa size={28} />
              </div>

              <div className="h-8 px-2 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-orange-500">
                <FaCcMastercard size={28} />
              </div>

              <div className="h-8 px-3 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 text-gray-700 gap-1.5">
                <FaMoneyBillWave className="text-green-600" size={20} />
                <span className="text-[10px] font-bold">COD</span>
              </div>

            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;